/* 由 translate.js 根据 translateSource.xlsx「链接领取Key」自动生成，请勿手改 */
export const ISO_TO_ZH_LOCALE_KEY: Record<string, string> = {
  "AU": "澳大利亚",
  "CA": "加拿大",
  "CN": "中国",
  "GB": "英国",
  "HK": "香港地区",
  "HKM": "柬埔寨",
  "ID": "印度尼西亚",
  "JP": "日本",
  "KR": "韩国",
  "MO": "澳门地区",
  "MY": "马来西亚",
  "PH": "菲律宾",
  "SG": "新加坡",
  "TH": "泰国",
  "TW": "台湾地区",
  "UAE": "阿联酋",
  "US": "美国",
  "VN": "越南",
};
